import { useLocation } from 'react-router-dom';

const useSetBackgroundColor = () => {
    const { pathname } = useLocation();

    const root = document.getElementById('root');

    switch (true) {
        case pathname === '/':
            root?.setAttribute('class', 'green-bg');
            break;
        case pathname === '/register' || pathname === '/register/':
            root?.setAttribute('class', 'green-bg');
            break;

        default:
            root?.setAttribute('class', '');
            break;
    }
};

export default useSetBackgroundColor;
